var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLcMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1111_371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.953 19.168V11.7275C44.953 8.83629 42.7105 6.49316 39.9436 6.49316H5.58589C2.83203 6.49316 0.576477 8.84999 0.576477 11.7275V32.3223C0.576477 35.2136 2.83203 37.5567 5.58589 37.5567H39.9436C42.7105 37.5567 44.953 35.2136 44.953 32.3223V28.0335C44.953 27.4032 44.4677 26.8825 43.8514 26.8825C43.2482 26.8825 42.7499 27.3895 42.7499 28.0335V32.3223C42.7499 33.9529 41.491 35.2684 39.9304 35.2684H5.57278C4.01226 35.2684 2.75334 33.9529 2.75334 32.3223V11.7275C2.75334 11.2753 2.85825 10.8506 3.04184 10.4532L8.64136 16.3041C9.061 16.7426 9.75602 16.7426 10.1757 16.3041C10.6084 15.8657 10.6084 15.1394 10.1757 14.6873L4.68104 8.94591C4.95643 8.83629 5.25805 8.76778 5.57278 8.76778H39.9304C40.2452 8.76778 40.5337 8.82259 40.8222 8.94591L24.6924 25.8C23.6171 26.9236 21.873 26.9236 20.7977 25.8L15.644 20.4149C15.2113 19.9627 14.5294 19.9627 14.0966 20.4149C13.6639 20.8671 13.6639 21.5796 14.0966 22.0318L19.2503 27.4169C20.2076 28.4171 21.4796 28.9241 22.7385 28.9241C23.9974 28.9241 25.2694 28.4171 26.2267 27.4169L42.4483 10.4532C42.6318 10.8506 42.7368 11.2753 42.7368 11.7275V19.168C42.7368 19.7983 43.222 20.319 43.8383 20.319C44.4415 20.319 44.9398 19.812 44.9398 19.168H44.953Z",
    fill: "#243D63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.3765,
    height: 44.3765,
    fill: "white",
    transform: "translate(0.576477 0.576416)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcMailIcon);
export default __webpack_public_path__ + "static/media/LCMailIcon.4f6c17347a375640bcd22acaf9da0011.svg";
export { ForwardRef as ReactComponent };